<!--AFFICHAGE BLOC DIRIGEANTS -->
<template>
  <v-col md="12" class="pa-3 d-flex flex-column" v-if="this.condition_actu()">
    <v-card elevation="2"  v-if="actuneg!=null" id="actun">
      <v-card-title>
      <v-icon large left> event </v-icon> Actualité négative
      </v-card-title>
<v-card-text>
          <v-flex v-for="actu in this.actuneg" :key="actu.date">
          <v-card  class="ma-3 " >
            <v-card-title>{{ actu.date }} : {{ actu.titre }}</v-card-title>
            <v-card-text >{{ actu.preview}}</v-card-text>
            <v-card-actions>

              <v-btn target = "_blank" :href="actu.lien">Ouvrir</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
  </v-card-text>
    </v-card>

    <v-card elevation="2"  v-if="actupos!=null" id="actup">
      <v-card-title>
      <v-icon large left> event </v-icon> Actualité positive
      </v-card-title>
      <v-card-text>
        <v-flex  v-for="actu in actupos" :key="actu.date">
          <v-card style="margin-bottom: 10px" >
            <v-card-title>{{ actu.titre }}</v-card-title>
            <v-card-text >{{ actu.preview}}</v-card-text>
            <v-card-actions>
              <v-btn ><v-icon>arrow_right</v-icon>Lire plus</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
        </v-card-text>
    </v-card>

  </v-col>
</template>

<script>
export default {
  name: "GoogleActu",
  props: ["etablissement"],
  components: {},
  computed: {
    actupos: function () {
     var actu =  this.$store.getters.getbloc("info", "indicateurs", "actu_positive")

      if (actu!=null) {
        return actu.valeur
      } else {
        return null
      }
    },
    actuneg: function () {
      var actu =  this.$store.getters.getbloc("info", "indicateurs", "actu_negative")
      if (actu!=null) {
        return actu.valeur
      } else {
        return null
      }    },

  },

  methods: {
      condition_actu() {
      return (
          (this.$store.getters.condition("info", "indicateurs", "actu_negative") &&
        this.etablissement.info.indicateurs.actu_negative.valeur != null) ||
               (this.$store.getters.condition("info", "indicateurs", "actu_positive") &&
        this.etablissement.info.indicateurs.actu_positive.valeur != null)
      );
    },

  },
};
</script>
